import { render, staticRenderFns } from "./ImageMaterial.vue?vue&type=template&id=0c2a9fbf&"
import script from "./ImageMaterial.vue?vue&type=script&lang=ts&"
export * from "./ImageMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports